export const actionTypes = {
  GET_PAYMENT_TERMS: "GET_PAYMENT_TERMS",
  SET_PAYMENT_TERMS: "SET_PAYMENT_TERMS",

  GET_PAYMENT_PARTNERS: "GET_PAYMENT_PARTNERS",
  SET_PAYMENT_PARTNERS: "SET_PAYMENT_PARTNERS",

  GET_TERMS_BY_ID: "GET_TERMS_BY_ID",
  SET_TERMS_BY_ID: "SET_TERMS_BY_ID",

  CREATE_TERM: "CREATE_TERM",
  UPDATE_TERM: "UPDATE_TERM",
  CLEAR_TERM: "CLEAR_TERM",

  EDIT_FORM_VIEW_STATUS: "EDIT_FORM_VIEW_STATUS"
};

export const actions = {
  getPaymentTerms: (payload) => ({
    type: actionTypes.GET_PAYMENT_TERMS,
    payload: payload,
  }),

  setPaymentTerms: (payload) => ({
    type: actionTypes.SET_PAYMENT_TERMS,
    payload: payload,
  }),

  getPaymentPartners: (payload) => ({
    type: actionTypes.GET_PAYMENT_PARTNERS,
    payload: payload,
  }),

  setPaymentPartners: (payload) => ({
    type: actionTypes.SET_PAYMENT_PARTNERS,
    payload: payload,
  }),

  getPaymentTermsById: (payload) => ({
    type: actionTypes.GET_TERMS_BY_ID,
    payload: payload,
  }),

  setPaymentTermsById: (payload) => ({
    type: actionTypes.SET_TERMS_BY_ID,
    payload: payload,
  }),

  createTerm: (payload) => ({
    type: actionTypes.CREATE_TERM,
    payload: payload,
  }),

  updateTerm: (payload) => ({
    type: actionTypes.UPDATE_TERM,
    payload
  }),

  clearTerm: (payload) => ({
    type: actionTypes.CLEAR_TERM,
    payload
  }),

  editFormViewStatus: (payload) => ({
    type: actionTypes.EDIT_FORM_VIEW_STATUS,
    payload
  })
};
